import { ICustomizerApiFilterOption } from './customizer-api-filter-option';

export class FilterOption implements ICustomizerApiFilterOption {
  public checked = false;
  public disabled = false;
  public key: string;
  public title: string;
  public value: string;
  public visible = false;

  constructor(apiFilterOption: ICustomizerApiFilterOption) {
    this.key = apiFilterOption.key;
    this.title = apiFilterOption.title;
    this.value = apiFilterOption.value;
  }

  public get id(): string {
    return `${this.key}-${this.value}`;
  }
}
